import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-apps',
  templateUrl: './mobile-apps.component.html',
  styleUrls: ['./mobile-apps.component.scss']
})
export class MobileAppsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
